export default "__VITE_ASSET__BEsFb$L8__"